import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Infrastructure">
                <h1>Infrastructure Migration Services</h1>
              </div>
              <p className="main_para">
                The team at Tekrevol comes in handy if you are looking for
                state-of-the-art infrastructure migration services in a
                business-oriented manner. At our core, we aim to revolutionize
                your business process through our seamless and effective
                migration service.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                With a team of professional developers who excel at what they
                do, We provide you with convenient and smooth infrastructure
                migration that does not halt your business performance
                regardless of the complexities. Taking into consideration all
                the relevant factors that your business prioritizes, we ensure
                to scale your business and support streamlined migration
                services.
              </p>
              <ul>
                <li>Scalable</li>
                <li>High-Performance</li>
                <li>Cost-Effective</li>
                <li>Result-Oriented</li>
                <li>Solution-Oriented Approach</li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
